export default function GTEX() {
    return (
        <div className="card">
            <h2>Spezial Event Xperience</h2>
            <p>Hier folgen später alle Informationen zu Spezialevents von Racevision.</p>
        </div>
    );
}
